import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function HowCreditAffectsApprovals() {
  return (
    <div className="bg-white text-[#0a2545]">
      {/* Hero Section */}
      <section
        className="relative h-[60vh] flex items-center justify-center text-center text-white"
        style={{
          backgroundImage:
            "linear-gradient(rgba(10,37,69,0.6), rgba(13,94,99,0.6)), url('/bl1.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="px-6"
        >
          <h1 className="text-5xl font-extrabold drop-shadow-lg">
            How Credit Really Affects Your Approval
          </h1>
          <p className="mt-4 text-lg text-gray-200 max-w-2xl mx-auto">
            Understanding your credit score and how we help you get approved
            even when banks say no.
          </p>
        </motion.div>
      </section>

      {/* Content Section */}
      <section className="max-w-5xl mx-auto py-16 px-6 leading-relaxed">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl font-bold mb-6 text-[#0a2545]"
        >
          What is a Credit Score?
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-gray-700 mb-8"
        >
          Your credit score is a numerical representation of how reliable you
          are at paying back borrowed money. Lenders use it to determine your
          ability to handle loans responsibly. But at{" "}
          <span className="text-teal-500 font-semibold">Yes Auto</span>, we look
          beyond the numbers — focusing on affordability, consistency, and your
          future potential.
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl font-bold mb-6 text-[#0a2545]"
        >
          How Yes Auto Makes It Easier
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          className="text-gray-700 mb-8"
        >
          Traditional lenders often reject applicants due to old debts or
          inconsistent payment history. Our in-house financing model allows us
          to tailor car loans that fit your income, not just your credit score.
          We believe in second chances and helping you rebuild financial
          strength.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="bg-gradient-to-r from-[#0a2545] to-[#0d5e63] p-10 rounded-3xl text-white shadow-lg"
        >
          <h3 className="text-2xl font-semibold mb-4">✨ Quick Tips</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-200">
            <li>Check your credit report regularly.</li>
            <li>Pay at least the minimum on time every month.</li>
            <li>Avoid opening too many new accounts at once.</li>
            <li>Keep your credit utilization under 30%.</li>
          </ul>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6 }}
          className="mt-12 text-center"
        >
          <p className="text-gray-700 mb-6">
            Want to learn how we can help you rebuild credit and still get your
            dream car?
          </p>
          <Link
            to="/financing"
            className="inline-block bg-teal-400 text-[#0a2545] px-8 py-3 rounded-full font-semibold shadow-lg hover:scale-[1.05] transition"
          >
            Apply for Financing
          </Link>
        </motion.div>
      </section>
    </div>
  );
}
